import {
  ReleaseVersion,
  UpdateReleaseVersionSongPatchData,
} from 'types/releases';
import { LabelVersionFormLoader } from 'app/components/Releases';
import {
  fetchLanguageCodesDDLEffect,
  fetchSongDDLEffect,
} from 'app/store/SongList/effects';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useResource } from 'app/utils/hooks';
import {
  getLanguageCodesSelector,
  getSongDDLSelector,
} from 'app/store/SongList/selectors';
import {
  fetchUpdateVersionSongValidationsEffect,
  syncVersionEffect,
  updateLabelVersionEffect,
} from 'app/store/Releases/effects';
import {
  getReleaseVersion,
  getUpdateVersionSongValidations,
  getVersionSyncStatus,
} from 'app/store/Releases/selectors';
import { LabelVersionDetailsFormComponent } from './LabelVersionDetailsFormComponent';

export const LabelVersionDetailsForm = () => {
  const dispatch = useAppDispatch();
  const releaseVersion = useAppSelector(getReleaseVersion) as ReleaseVersion;
  const [songDDL, songDDLLoading] = useResource(
    fetchSongDDLEffect,
    getSongDDLSelector
  );
  const [languageCodes, languageCodesLoading] = useResource(
    fetchLanguageCodesDDLEffect,
    getLanguageCodesSelector
  );
  const [versionSongValidations, versionSongValidationsLoading] = useResource(
    fetchUpdateVersionSongValidationsEffect,
    getUpdateVersionSongValidations
  );

  const isSyncing =
    useAppSelector((state) =>
      getVersionSyncStatus(state, releaseVersion?.song.versionGuid || '')
    ) || false;

  const updateSongVersion = async (
    formData: UpdateReleaseVersionSongPatchData
  ) => {
    try {
      await dispatch(updateLabelVersionEffect({ formData })).unwrap();
    } catch {
      // proceed
    }
  };

  const syncSongVersion = async () => {
    await dispatch(
      syncVersionEffect({
        versionGuid: releaseVersion?.song.versionGuid as string,
        songGuid: releaseVersion?.metadata.songGuid as string,
      })
    );
  };

  if (versionSongValidationsLoading || languageCodesLoading || songDDLLoading) {
    return <LabelVersionFormLoader />;
  }

  return languageCodes &&
    songDDL &&
    releaseVersion &&
    versionSongValidations ? (
    <LabelVersionDetailsFormComponent
      releaseVersion={releaseVersion}
      languageCodes={languageCodes}
      songDDL={songDDL}
      validations={versionSongValidations}
      updateSongVersion={updateSongVersion}
      syncSongVersion={syncSongVersion}
      isSyncing={isSyncing}
    />
  ) : null;
};
